<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">

            <b-row>
                <b-col col sm="12">
                    <b-card no-body>
                        <div class="card shadow">
                            <div class="card-header bg-transparent">
                                <div>
                                    <h3 class="float-left mb-0">
                                        {{ $t('message.response') + ' ' + $t('message.medicalAdvice') }}
                                    </h3>
                                </div>

                                <div class="">
                                    <div class="card-title ml-3">
                                    </div>
                                    <b-container>
                                        <section>
                                            <b-form class="mt-4">
                                                <b-container>

                                                    <div class="row response-medicalAdvice">
                                                        <div class="col-md-12">
                                                            <span class="description-label mb-2">
                                                                {{ $t('message.description') }}:
                                                            </span>
                                                            <p class="description-content mb-0" v-html="medicalAdvice.description">
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <br>

                                                    <b-row>
                                                        <b-col md="12" sm="12">
                                                            <span class="description-label mb-2">
                                                                {{ $t('message.response') }}:
                                                            </span>
                                                            <b-form-group
                                                                    id="motif-group"
                                                                    label-for="motif">
                                                                <editor
                                                                        :api-key="tinyKey"
                                                                        id="motif"
                                                                        v-model="$v.form.response.$model"
                                                                        :state="$v.form.response.$dirty ? !(errorshasField('response') || $v.form.response.$error) : null"
                                                                        placeholder=""
                                                                        @focus="clearErrorField('response')"
                                                                        :init="{
                                                                          height: 200,
                                                                          menubar: false,
                                                                          plugins: plugins,
                                                                          toolbar:toolbar
                                                                        }"
                                                                >
                                                                </editor>
                                                                <b-form-invalid-feedback v-if="errorshasField('response')">
                                                                    {{ getErrorsField('response') }}
                                                                </b-form-invalid-feedback>

                                                                <b-form-invalid-feedback v-if="$v.form.response.$error">
                                                                    {{ $t('message.requiredField') }}
                                                                </b-form-invalid-feedback>

                                                            </b-form-group>

                                                        </b-col>
                                                    </b-row>

                                                    <b-row class="">
                                                        <b-col md="6" sm="12">
                                                            <b-button @click="onSubmit" variant="primary">
                                                                {{ $t('message.save') }}
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-container>
                                            </b-form>
                                        </section>
                                    </b-container>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
	import * as _ from "lodash";
	import {mapGetters} from "vuex";
	import {required} from 'vuelidate/lib/validators';
	import Editor from '@tinymce/tinymce-vue';
	import AppConfig from "../../constants/AppConfig";

    export default {
        name: "ResponseMedicalAdvice",

		components: {
			editor: Editor
		},

        computed: {
            ...mapGetters([
				"practitioners",
				"controlDoctors",
                "patients",
                "medicalAdvice",
				"adviceResponse",
            ]),

			mPatients: function() {
				let pArray = [];

				_.forEach(this.patients, function(patient) {
					if (typeof patient.user == 'object' && patient.user.isMedicasure){
						let user = patient.user;
						if (typeof patient.dossier == "object"){
							let dossier  = patient.dossier;
							let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
							prenom =  prenom.toLowerCase();
							let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
							pArray.push({text: text, value: patient.dossier.id });
						}
					}
				});

				return pArray;
			},

			mPractitioners: function() {
				let pArray = [];

				_.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
					let p = {};
					// if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
					if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure){
						// console.log('practitioner.user.isMedicasure => ', practitioner.user.isMedicasure);
						let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
						prenom =  prenom.toLowerCase();
						p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						p.id = practitioner.user.id;
						if (p.nom.length >0){
							pArray.push(p);
						}
					}

				});

				return pArray;
			},

			mDoctors: function() {
				let dArray = [];

				_.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
					let d = {};
					// if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure == '1'){
					if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure){
						let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
						prenom =  prenom.toLowerCase();
						d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						d.id = doctor.user.id;

						if (d.nom.length >0){
							dArray.push(d);
						}
					}

				});

				return dArray;
			},

			mContributors:function () {
				let cArray = [];
				return cArray.concat(this.mDoctors,this.mPractitioners);
			}
        },

        data() {
            return {
				form:{
					response: '',
					// this field is hidden and its value if filled automatically
					slug: ''
				},
				offset: 0,
				limit: -1,
				medicalAdviceSlug: this.$route.params.medicalAdviceSlug,
				adviceResponseSlug: null,
				tinyKey: AppConfig.tinyMceKey,
				plugins : [
					'advlist autolink lists image charmap',
					'searchreplace visualblocks code fullscreen',
					'print preview anchor insertdatetime media',
					'paste code help wordcount table'
				],
				toolbar : 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
            };
        },
        watch: {
			medicalAdvice: function (newMedicalAdvice, oldMedicalAdvice) {
				// console.log('newMedicalAdvice => ', newMedicalAdvice);
			},
			adviceResponse: function (newAdviceResponse, o) {
				this.adviceResponseSlug = newAdviceResponse.slug;
				// console.log('newAdviceResponse => ', newAdviceResponse);
				// console.log('this.adviceResponseSlug => ', this.adviceResponseSlug);
			},
        },
        methods: {

			getAdviceResponse() {
				const args = {
					adviceSlug: this.medicalAdviceSlug
				};
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				this.$store.dispatch('getAdviceResponse', { args, errorMessages });
			},

			getMedicalAdvice() {
				const args = {
					avis: this.medicalAdviceSlug
				};
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				this.$store.dispatch('getMedicalAdvice', { args, errorMessages });
			},

			onSubmit() {
            	event.preventDefault();
            	// console.log('form => ', this.form);
				event.preventDefault();
				this.$v.$touch();

				if (!this.$v.$invalid ) {
					const args = {
						avis: this.form.response,
                        view: '1',
					};

					const successMessage = this.$i18n.t('message.adviceResponseSent');
					const errorMessages = {
						generic: this.$i18n.t('message.genericError'),
						error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
					};

					const payload = {
						args,
                        errorMessages,
						medicalAdviceSlug: this.medicalAdviceSlug,
						adviceResponseSlug: this.adviceResponseSlug,
                        shouldSentNotification: true,
                        shouldRedirect: true,
                        successMessage,
                    };

					this.$store.dispatch('updateDoctorAdvice', payload);
				}
            },

			getPatients: function() {
				this.$store.dispatch('getPatients', { args: {} });
			},

			getDoctors() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getControlDoctors', { args : args });
			},

			getPractitioners() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getPractitioners', { args : args });
			},

			errorshasField(field) {
				return this.errors ? this.errors.hasOwnProperty(field) : false;
			},

			clearErrorField(field) {
				this.$store.dispatch('clearErrorField', {field});

				this.errorshasField(field);
			}
        },
		validations() {
			return {
				form: {
					response:{
						required
					},
				}
			}
		},
        mounted() {
            this.getMedicalAdvice();

			this.getAdviceResponse();

            this.getPatients();

			// Fetch control doctor list
			this.getDoctors();

			// Fetch practitioner list
			this.getPractitioners();
        }
    }
</script>





<style scoped lang="scss">
    .description-label {
        opacity: 0.9;
        color: #121212;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.4px;
        text-transform: uppercase;
    }
</style>
